import { isBefore } from "date-fns";
import { IdentifiedPatientState } from "./consent.dtos";
import { StudyStatus } from "./study.dtos";
export function isPatientActivelySharingConsent(consent) {
    if (consent.pending)
        return false;
    return consent.state === IdentifiedPatientState.ENROLLED;
}
export function isProjectActiveForSharing(study) {
    return ![StudyStatus.COMPLETED, StudyStatus.WITHDRAWN].includes(study.status) && !study.isCompletionDateExpired;
}
export function isProjectActiveForSharingByCompletionDate(status, completionDate) {
    if ([StudyStatus.COMPLETED, StudyStatus.WITHDRAWN].includes(status))
        return false;
    if (completionDate === null || completionDate === undefined)
        return true;
    return isBefore(new Date(), new Date(completionDate));
}
